import HttpWrapper from '../../http-wrapper';
const { instance: axios } = HttpWrapper.axiosCreate();

export const suggestionsApiService = {
    getSuggestions(suggestionApi, term) {
        return axios
            .get(suggestionApi + term)
            .then(response => response.data);
    },
};
